import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, IconButton, Icon, Typography, Dialog, DialogTitle, DialogContent } from '@material-ui/core';
import { Breadcrumb, BackdropCircular, ConfirmDialog } from 'components';
import { deleteTermsAndConditionsAPI, getTermsAndConditionsListAPI } from 'api';
import MUIDataTable from 'mui-datatables';
import { DeleteIcon } from 'components/CustomSVG';
import EditAgreement from './EditAgreement';


const TermsAndConditionsConfig = () => {
  const dispatch = useDispatch();
  const [openEditAgreementDialog, setOpenEditAgreementDialog] = useState(false);
  const [agreementIdToDelete, setAgreementIdToDelete] = useState(null);
  const [editableAgreement, setEditableAgreement] = useState({});

  const {termsAndConditionsList, loadingTermsAndConditions} = useSelector((state) => state.quote);

  useEffect(() => {
    getTermsAndConditionsListAPI({dispatch});
  }, []);

  const handleConfirmDelete = () => {
    deleteTermsAndConditionsAPI({ dispatch, id: agreementIdToDelete });
  };

  return (
    <div className="flex-grow flex-column relative h-full scroll-y">
      <div>
        <Breadcrumb
          routeSegments={[
            { name: 'Settings', path: '/settings#go_live_requirements' },
            { name: 'QuotePRO Configurations', path: '/settings#QuotePRO_configurations' },
            { name: 'Terms and Conditions' }
          ]}
        />
      </div>
      <div className="mt-10 mx-10">
        <Card className="p-8">
          <Typography variant="h4" className="mb-4">QuotePRO Store Agreements</Typography>
          <MUIDataTable
            data={termsAndConditionsList}
            columns={[
              {
                name: 'name',
                label: 'Name',
                options: {
                  customBodyRenderLite: (dataIndex) => {
                    const agreement = termsAndConditionsList[dataIndex];

                    return (
                      <div>{agreement.name} {agreement.isSubscription ? 'S' : ''}</div>
                    );
                  }
                }
              },
              {
                name: 'isSubscription',
                label: 'Type',
                options: {
                  customBodyRenderLite: (dataIndex) => {
                    const agreement = termsAndConditionsList[dataIndex];

                    return (
                      agreement.isSubscription ? 'Subscription' : 'Default'
                    );
                  }
                }
              },
              {
                name: 'Action',
                lable: 'Action',
                options: {
                  filter: false,
                  setCellHeaderProps: () => ({ style: { width: '100px' }}),
                  customBodyRenderLite: (dataIndex) => {
                    const agreement = termsAndConditionsList[dataIndex];
                    return (
                      <div className="flex">
                        <IconButton
                          title="Click here to delete agreement"
                          className="px-1"
                          onClick={() => {
                            setAgreementIdToDelete(agreement.agreement_id);
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                        <IconButton
                          title="Click here to edit agreement"
                          onClick={() => {
                            setEditableAgreement(agreement);
                            setOpenEditAgreementDialog(true);
                          }}
                        >
                          <Icon>edit</Icon>
                        </IconButton>
                      </div>
                    );
                  }
                }
              }
            ]}
            options={{
              filterArrayFullMatch: false,
              filterType: 'textField',
              responsive: 'standard',
              selectableRows: 'none',
              search: false,
              filter: false,
              download: false,
              print: false,
              pagination: false,
              viewColumns: false,
              elevation: 0,
            }}
          />
        </Card>
        <div className="flex justify-end">
          <Button
            variant="contained"
            color="primary"
            className="my-10"
            onClick={() => setOpenEditAgreementDialog(true)}
          >
            Create New Agreement
          </Button>
        </div>
        <ConfirmDialog
          title="Delete Agreement?"
          open={Boolean(agreementIdToDelete)}
          setOpen={setAgreementIdToDelete}
          onConfirm={handleConfirmDelete}
        >
          Are you sure you want to delete the agreement?
        </ConfirmDialog>
        {openEditAgreementDialog &&
          <Dialog
            open={openEditAgreementDialog}
            onClose={() => {
              setOpenEditAgreementDialog(false);
              setEditableAgreement({});
            }}
            maxWidth={'lg'}
            fullWidth
          >
            <DialogTitle>
              <Typography variant="h4" className="mt-4">{Object.keys(editableAgreement).length ? 'Edit Agreement' : 'Create Agreement'}</Typography>
            </DialogTitle>
            <DialogContent  className="m-4">
              <EditAgreement
                setOpenEditAgreementDialog={setOpenEditAgreementDialog}
                editableAgreement={editableAgreement}
                setEditableAgreement={setEditableAgreement}
              />
            </DialogContent>
          </Dialog>
        }
        <BackdropCircular loading={loadingTermsAndConditions} />
      </div>
    </div>
  );
};

export default TermsAndConditionsConfig;
